export enum ValidationDataStatus {
    Active = 0,
    Inactive = 1,
    RestrictedTimekeeper = 2,
    TimeOnly = 3,
    ExpenseOnly = 4,
    RestrictedUser = 5,
    WalledUser = 6,
    Invalid = 7
}